import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { FAQS } from '../../lib/constants';

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="section-pad bg-brand-bg">
      <div className="container-prep">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
            <p className="eyebrow mb-5">FAQ</p>
            <h2 className="heading-2 mb-6">
              YUMI Lash Lift Vancouver —
              <span className="italic block text-brand-gold">Frequently Asked Questions.</span>
            </h2>
            <p className="body-lg">
              Everything you need to know before your appointment. Still curious?
              Call us at{' '}
              <a href="tel:+16047646452" className="text-brand-cream underline decoration-brand-gold underline-offset-4 hover:text-brand-gold">
                604-764-6452
              </a>.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="border-b border-brand-gold/15"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger
                    className="text-left font-serif text-lg sm:text-xl text-brand-cream hover:text-brand-gold hover:no-underline py-6 [&[data-state=open]]:text-brand-gold"
                    data-testid={`faq-trigger-${i}`}
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-muted leading-relaxed text-base pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
